import { Button, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import ArrowBackground from 'v2/assets/vector/ArrowBackground';
import { HOME_PATH } from 'v2/paths';

const NoAccess: FC = () => {
  const { translation } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" justifyContent="center" gap={3} sx={{ height: 'calc(100vh - 160px)' }}>
      <ArrowBackground sx={{ position: 'fixed', right: 0, bottom: 0, width: '15vw', height: 'auto', zIndex: -1 }} />
      <Stack alignItems="center" gap={1} maxWidth="480px">
        <Typography variant="h3" color="primary">
          {translation.no_access}
        </Typography>
        <Typography color="textSecondary" textAlign="center">
          {translation.no_access_description}
        </Typography>
      </Stack>
      <Button id="back-to-home-button" variant="contained" color="primary" onClick={() => navigate(HOME_PATH)}>
        {translation.back_to_home}
      </Button>
    </Stack>
  );
};

export default NoAccess;
